import { hideLoading } from 'app/commons/helpers/loadingUtils'

import { useEffect } from 'react'

let showPopup = true

// Prevent show popup twice.
function togglePopup() {
  showPopup = false
  setTimeout(() => {
    showPopup = true
  }, 100)
}

function useBeforeUnload(fn) {
  useEffect(() => {
    function handleUnload(e) {
      if (!showPopup) {
        return
      }

      hideLoading()
      e.preventDefault()
      e.returnValue = ''

      if (typeof fn === 'function') {
        fn()
      }

      togglePopup()
    }

    window.onbeforeunload = handleUnload
    return () => (window.onbeforeunload = null)
  }, [fn])
}

export default useBeforeUnload
